module.exports = __webpack_public_path__ + "static/media/dashboard-account.e51b1359.svg";